module.exports = __webpack_public_path__ + "img/03.a991c41e.jpg";